import { render, staticRenderFns } from "./_register.vue?vue&type=template&id=1806765d&scoped=true"
import script from "./_register.vue?vue&type=script&lang=js"
export * from "./_register.vue?vue&type=script&lang=js"
import style0 from "./_register.vue?vue&type=style&index=0&id=1806765d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806765d",
  null
  
)

export default component.exports